const SearchInput = ({ debouncedHandleSearchChange, placeholderText }) => {
    return (
        <>
            <input
                onChange={debouncedHandleSearchChange}
                type="search"
                className="form-control"
                placeholder={placeholderText}
                aria-controls="myTable"
                style={{
                    height: '50px',
                    color: '#292B2E',
                    fontSize: '16px',
                    borderRadius: '5px',
                    paddingLeft: '10px'
                }}
            />
            <i
                className="fa-solid fa-magnifying-glass position-absolute"
                style={{
                    left: '90%',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: 'blue'
                }}
            ></i>
        </>
    )
}

export default SearchInput